export const ContactItems = [
    {
        name: 'Email',
        href: 'mailto:parthpatel1087@gmail.com',
        itemImage: 'fas fa-home',
        typeImage: 'far fa-envelope',
    },
    {
        name: 'Linkedin',
        href: 'https://www.linkedin.com/in/parthpatel-patel',
        itemImage: 'fab fa-linkedin',
        typeImage: 'fas fa-external-link-alt',
    },
    {
        name: 'GitHub',
        href: 'https://www.github.com/parth-commits',
        itemImage: 'fab fa-github',
        typeImage: 'fas fa-external-link-alt',
    },
]
